class AddToCartModal extends ModalDialog {
    constructor() {
        super()
        this.loading = true
        this.cartDrawer = document.querySelector('cart-drawer')
    }

    /**
     * @param {boolean} state
     */
    set loading(state = true) {
        this._loading = state
        if (state)
            this.querySelector('.loading__spinner').classList.remove('hidden');
        else
            this.querySelector('.loading__spinner').classList.add('hidden');
    }
    connectedCallback() {
        this.querySelector('#continue-shopping').addEventListener('click', () => {
            this.hide();
        });
    }

    renderContents(parsedState) {
        setTimeout(() => {
            this.show();
        });
        this.cartItemKey = parsedState.key;
        this.getSectionsToRender().forEach((section) => {
            const sectionEl = document.getElementById(section.id)
            if (sectionEl)
                sectionEl.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.id],
                    section.selector
                );
        });
        this.loading = false
        //update cart drawer also 
        this.cartDrawer.renderContents(parsedState, true)
    }

    getSectionsToRender() {
        return [
            {
                id: 'add-to-cart-product',
                selector: `[id="add-to-cart-product-${this.cartItemKey}"]`,
            },
            ...this.cartDrawer.getSectionsToRender()
        ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    setActiveElement(element) {
        this.openedBy = element
    }
}

customElements.define('add-to-cart-modal', AddToCartModal)